<div class="card">
  <div class="card-body">
    <div [innerHTML]="html" class="inner-html"></div>
  </div>
</div>
